import { Box, Button, Checkbox, CircularProgress, FormControlLabel, Grid, Link, Typography } from "@material-ui/core";
import { green, red } from "@material-ui/core/colors";

import DoneIcon from "@material-ui/icons/Done";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { Fragment } from "react";
import { enumMaxWidth } from "../../settings/enumConfig";
import { useConfirmarSolicitud } from "../../context/ConfirmarSolicitudContext";
import { useProveedoresProspectos } from "../../context/ProveedoresProspectosContext";

const EnviarSolicitud = () => {
    const { entSolicitudDetalleForEdit } = useProveedoresProspectos();
    const {
        confirmarForm,
        errorAvisoPrivacidad,
        folioRespuesta,
        enviando,
        exito,
        error,
        errorGuardadoMessage,
        handleChangeConfirmarCheck,
        handleClickRegresar,
        handleClickReintentar,
        handleClickEnviarSolicitud,
    } = useConfirmarSolicitud();

    const { txtAvisoPrivacidad } = confirmarForm;

    return (
        <Fragment>
            <Grid container spacing={4} className="content-over">
                <Grid item xs={12}>
                    <Box style={{ borderRadius: "15px", maxWidth: enumMaxWidth, margin: "auto" }}>
                        <Grid container spacing={4}>
                            {!exito && !error && !enviando && (
                                <Fragment>
                                    <Grid item xs={12} className="center">
                                        {!entSolicitudDetalleForEdit && (
                                            <Typography>
                                                Para finalizar con la solicitud, acepte el{" "}
                                                <Link
                                                    href="http://20.42.26.58:8080/Compras_Test/Doc/Aviso_Privacidad_ESP.PDF"
                                                    target="_blank"
                                                    rel="noreferrer noopener"
                                                >
                                                    aviso de privacidad
                                                </Link>{" "}
                                                y de clic en "Finalizar".
                                            </Typography>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
                                        <div style={{ maxWidth: 500 }}>
                                            <FormControlLabel
                                                label={!entSolicitudDetalleForEdit ? txtAvisoPrivacidad.label : txtAvisoPrivacidad.label2}
                                                control={
                                                    <Checkbox
                                                        color="primary"
                                                        checked={txtAvisoPrivacidad.value}
                                                        onChange={(e) => handleChangeConfirmarCheck(e, txtAvisoPrivacidad.name)}
                                                    />
                                                }
                                            />
                                        </div>
                                    </Grid>
                                    {errorAvisoPrivacidad && (
                                        <Grid item xs={12} className="center">
                                            <Typography color="error">
                                                {!entSolicitudDetalleForEdit
                                                    ? "Es encesario aceptar el aviso de privacidad para enviar a solicitud"
                                                    : "Para continuar, acepte la declaración de reemplazo de información"}
                                            </Typography>
                                        </Grid>
                                    )}
                                </Fragment>
                            )}
                            {!exito && !error && enviando && (
                                <Fragment>
                                    <Grid item xs={12} className="center">
                                        <CircularProgress />
                                        <Typography>
                                            {!entSolicitudDetalleForEdit ? "Enviando solicitud..." : "Guardando solicitud..."}
                                        </Typography>
                                    </Grid>
                                </Fragment>
                            )}
                            {exito && (
                                <Fragment>
                                    <Grid item xs={12} className="center">
                                        <Typography>
                                            {!entSolicitudDetalleForEdit
                                                ? "Su solicitud ha sido enviada exitosamente"
                                                : "La solicitud ha sido actualizada"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} className="center">
                                        <DoneIcon style={{ color: green[500], fontSize: 100 }} />
                                    </Grid>
                                    <Grid item xs={12} className="center">
                                        <Typography variant="h6">FOLIO: {folioRespuesta}</Typography>
                                    </Grid>
                                    {!entSolicitudDetalleForEdit && (
                                        <Grid item xs={12} className="center">
                                            <Typography variant="body2">
                                                Nuestro equipo comenzará a evaluar la información proporcionada
                                            </Typography>
                                        </Grid>
                                    )}
                                    {entSolicitudDetalleForEdit && (
                                        <Grid item xs={12} className="center">
                                            <Typography variant="body1">Ya puede cerrar esta página</Typography>
                                        </Grid>
                                    )}
                                </Fragment>
                            )}
                            {error && (
                                <Fragment>
                                    <Grid item xs={12} className="center">
                                        <Typography>{errorGuardadoMessage}</Typography>
                                    </Grid>
                                    <Grid item xs={12} className="center">
                                        <ErrorOutlineIcon style={{ color: red[500], fontSize: 100 }} />
                                    </Grid>
                                    <Grid item xs={12} className="center">
                                        <Typography variant="body2">
                                            Esto puede deberse a un error temporal. Reintente nuevamente o intente más tarde
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} className="center">
                                        <Button variant="contained" color="primary" onClick={handleClickReintentar}>
                                            Reintentar
                                        </Button>
                                    </Grid>
                                </Fragment>
                            )}
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
            <Grid container spacing={4}>
                {!exito && !error && !enviando && (
                    <Grid item xs={12}>
                        <div className="form-buttons">
                            <Button variant="contained" color="secondary" onClick={handleClickRegresar}>
                                Regresar
                            </Button>
                            <Button variant="contained" color="primary" style={{ marginLeft: 10 }} onClick={handleClickEnviarSolicitud}>
                                {!entSolicitudDetalleForEdit ? "Finalizar y enviar solicitud" : "Finalizar y guardar solicitud"}
                            </Button>
                        </div>
                    </Grid>
                )}
            </Grid>
        </Fragment>
    );
};

export default EnviarSolicitud;
